// ! ichan qala
import ichan1 from "../../photos/uzb_xiva_ichan1.webp";
import ichan2 from "../../photos/uzb_xiva_ichan2.webp";
import ichan3 from "../../photos/uzb_xiva_ichan3.webp";

// ! kalta minor
import kalta1 from "../../photos/uzb_xiva_kalta1.webp";
import kalta2 from "../../photos/uzb_xiva_kalta2.webp";
import kalta3 from "../../photos/uzb_xiva_kalta3.webp";

// ! ko‘hna ark
import ark1 from "../../photos/uzb_xiva_ark1.webp";
import ark2 from "../../photos/uzb_xiva_ark2.webp";
import ark3 from "../../photos/uzb_xiva_ark3.webp";

// ! islom xo‘ja minorasi
import islom1 from "../../photos/uzb_xiva_islom1.webp";
import islom2 from "../../photos/uzb_xiva_islom2.webp";
import islom3 from "../../photos/uzb_xiva_islom3.webp";

// ! muhammad aminxon madrasasi
import madrasa1 from "../../photos/uzb_xiva_madrasa1.webp";
import madrasa2 from "../../photos/uzb_xiva_madrasa2.webp";
import madrasa3 from "../../photos/uzb_xiva_madrasa3.webp";

const khiva = {
    uz: {
        key: "khiva",
        title: "Xiva — ochiq osmon ostidagi muzey shahar",

        intro: `
Xiva — O‘zbekistonning eng qadimiy va eng yaxshi saqlanib qolgan tarixiy shaharlaridan biri.
U “ochiq osmon ostidagi muzey” deb ataladi, chunki butun eski shahar — Ichan-Qal’a deyarli o‘zgarmagan holda saqlangan.
    `,

        history: `
Xiva 2500 yildan ortiq tarixga ega bo‘lib, qadimda Xorazm sivilizatsiyasining muhim markazi bo‘lgan.

Buyuk Ipak Yo‘li davrida Xiva Sharq va G‘arb o‘rtasidagi savdo shahri sifatida katta ahamiyatga ega bo‘lgan.

XVI–XIX asrlarda Xiva Xonligining poytaxti bo‘lgan va mustaqil davlat sifatida rivojlangan.

Shahar ichidagi Ichan-Qal’a to‘liq saqlangan tarixiy majmua bo‘lib, UNESCO merosi ro‘yxatiga kiritilgan.
    `,

        sections: [

            {
                title: "Ichan-Qal’a — Xiva (Xorazm)",

                content: `
Ichan-Qal’a — Xiva shahrining ichki tarixiy qal’asi bo‘lib, O‘zbekistonning eng qadimiy va eng yaxshi saqlanib qolgan shaharlardan biridir.

Bu hudud Xorazm sivilizatsiyasining markazi bo‘lgan va ming yillar davomida ilm-fan, savdo, madaniyat va davlat boshqaruvi rivojlangan muhim shahar sifatida tanilgan.

Bugungi kunda Ichan-Qal’a ochiq osmon ostidagi muzey shahar sifatida butun dunyo sayyohlarini o‘ziga jalb qiladi.
    `,

                details: `
Ichan-Qal’a Xivaning ichki qal’a qismi bo‘lib, uning devorlari taxminan X–XIX asrlar davomida shakllangan.

📌 Tarixiy rivojlanish:
Xiva qadimda Buyuk Ipak yo‘li ustida joylashgan muhim savdo markazi bo‘lgan. Shahar Xorazmshohlar davlati, keyinchalik Xiva xonligi poytaxti bo‘lib xizmat qilgan.

📌 Ichan-Qal’a tarkibi:
- Ko‘hna Ark (xonlar qarorgohi)
- Muhammad Aminxon madrasasi
- Kalta Minor minorasi
- Juma masjidi (ming ustunli masjid)
- Toshhovli saroyi
- Islom Xo‘ja minorasi va madrasasi

📌 Arxitektura:
- Loy g‘ishtdan qurilgan qadimiy devorlar
- Moviy va yashil koshinlar
- Sharqona geometrik naqshlar
- Yopiq ko‘chalar va tor yo‘laklar
- Qadimiy shahar rejalashtirish uslubi

📌 Ahamiyati:
Ichan-Qal’a Markaziy Osiyoda to‘liq saqlanib qolgan yagona qadimiy shahar hisoblanadi.
U 1990-yilda UNESCO Jahon merosi ro‘yxatiga kiritilgan.
    `,

                facts: [
                    "Xiva shahri Xorazm viloyatida joylashgan",
                    "Ichan-Qal’a qadimiy ichki shahar hisoblanadi",
                    "UNESCO Jahon merosi ro‘yxatiga kiritilgan (1990)",
                    "Buyuk Ipak yo‘li ustida joylashgan muhim savdo markazi bo‘lgan",
                    "Xiva Xorazmshohlar va Xiva xonligi poytaxti bo‘lgan",
                    "Ko‘hna Ark xonlar qarorgohi bo‘lgan",
                    "Kalta Minor tugallanmagan minorasi bilan mashhur",
                    "Juma masjidi 200 dan ortiq yog‘och ustunlarga ega",
                    "Islom Xo‘ja minorasi Xivaning eng baland minorasi",
                    "Toshhovli saroyi xonlar yashash joyi bo‘lgan",
                    "Qadimiy devorlar loy g‘ishtdan qurilgan",
                    "Shahar 2000 yildan ortiq tarixga ega",
                    "Ichan-Qal’a to‘liq saqlangan ochiq muzey shahar",
                    "Sharq me’morchiligining eng yaxshi namunalaridan biri",
                    "Ko‘plab tarixiy madrasa va masjidlar mavjud",
                    "Shahar rejalashtirish o‘rta asrlarga oid",
                    "Ichki shahar devorlari hanuzgacha saqlangan",
                    "Turizm uchun eng mashhur joylardan biri",
                    "O‘zbekistonning eng qadimiy shaharlaridan biri",
                    "Kechasi yoritilganda juda cinematic ko‘rinadi"
                ],
                images: [ichan1, ichan2, ichan3,]
            },

            {
                title: "Kalta Minor — Xiva",

                content: `
Kalta Minor — Xiva shahrining eng mashhur va ramziy me’moriy yodgorliklaridan biridir.

U Ichan-Qal’a markazida joylashgan bo‘lib, o‘zining keng poydevori va yorqin ko‘k koshinlari bilan darhol e’tiborni tortadi.

Kalta Minor to‘liq qurilmagan bo‘lsa ham, Xivaning eng taniqli ramziga aylangan.
    `,

                details: `
Kalta Minor 1851-yilda Xiva xoni Muhammad Aminxon tomonidan qurdirila boshlangan.

Rejaga ko‘ra, bu minora juda baland bo‘lishi kerak edi — hatto Markaziy Osiyodagi eng baland minora bo‘lishi rejalashtirilgan.

Lekin qurilish 1855-yilda to‘xtab qolgan va minora tugallanmay qolgan.

📌 Arxitektura xususiyatlari:
- Keng va massiv poydevor
- Moviy va yashil koshinlar
- Geometrik islomiy naqshlar
- Qalin g‘isht devorlar

📌 Ahamiyati:
Kalta Minor Xivaning “tugallanmagan, lekin mukammal ramzi” hisoblanadi va bugungi kunda shaharning eng ko‘p suratga olinadigan obidasi.
    `,

                facts: [
                    "Xiva shahrida, Ichan-Qal’ada joylashgan",
                    "1851-yilda qurilishi boshlangan",
                    "Muhammad Aminxon tomonidan qurdirilgan",
                    "Tugallanmagan minora",
                    "Eng mashhur Xiva ramzi",
                    "Agar tugaganida eng baland minora bo‘lardi",
                    "Ko‘k koshinlar bilan bezatilgan",
                    "XIX asr me’morchiligi",
                    "Ichan-Qal’a markazida joylashgan",
                    "Turistlar eng ko‘p suratga oladigan joy",
                    "Sharq me’morchiligining noyob namunasi",
                    "Keng poydevorga ega",
                    "Qurilish 1855-yilda to‘xtagan",
                    "Xiva xonligi davriga tegishli",
                    "Xivaning asosiy timsoli hisoblanadi",
                    "UNESCO meros hududida joylashgan",
                    "Eng yorqin ko‘k koshinli obidalardan biri",
                    "O‘rta Osiyodagi eng mashhur minoralardan biri",
                    "Tarixiy va turistik ahamiyati juda yuqori",
                    "Kechasi juda chiroyli ko‘rinadi"
                ],
                images: [kalta1, kalta2, kalta3,]
            },

            {
                title: "Ko‘hna Ark — Xiva",

                content: `
Ko‘hna Ark — Xiva shahridagi eng muhim tarixiy majmualardan biri bo‘lib, u Xiva xonlarining rasmiy qarorgohi bo‘lgan.

Bu maskan Ichan-Qal’a ichida joylashgan bo‘lib, davlat boshqaruvi, harbiy ishlar va xon saroy hayoti aynan shu yerda yuritilgan.

Ko‘hna Ark Xivaning siyosiy va ma’muriy markazi sifatida asrlar davomida xizmat qilgan.
    `,

                details: `
Ko‘hna Ark majmuasi XVII asr oxiri — XVIII asr boshlarida shakllana boshlagan va keyinchalik kengaytirilgan.

📌 Tuzilishi:
Ko‘hna Ark bir nechta asosiy bo‘limlardan iborat:
- Xon saroyi (qarorgoh)
- Qabul zallari
- Devonxona (davlat boshqaruvi idorasi)
- Harbiy qurolxona
- Masjid va ibodat xonalari
- Kuzatuv minoralari

📌 Tarixiy ahamiyati:
Ko‘hna Ark Xiva xonligining yuragi hisoblangan. Bu yerda:
- davlat qarorlari qabul qilingan
- elchilar qabul qilingan
- harbiy strategiyalar ishlab chiqilgan

📌 Arxitektura:
- Loy g‘ishtdan qurilgan mustahkam devorlar
- Sharqona naqsh va koshin bezaklari
- Ichki hovlilar tizimi
- Qal’a uslubidagi mudofaa devorlari

Bugungi kunda Ko‘hna Ark Xivaning eng ko‘p tashrif buyuriladigan tarixiy obidalaridan biri hisoblanadi.
    `,

                facts: [
                    "Xiva shahrida Ichan-Qal’ada joylashgan",
                    "XVII–XVIII asrlarda shakllangan",
                    "Xiva xonlarining qarorgohi bo‘lgan",
                    "Davlat boshqaruv markazi bo‘lgan",
                    "Devonxona mavjud bo‘lgan",
                    "Harbiy boshqaruv joyi bo‘lgan",
                    "Qabul zallari mavjud",
                    "Masjid va ibodat xonasi bor",
                    "Loy g‘ishtdan qurilgan",
                    "Qal’a uslubidagi inshoot",
                    "Ichan-Qal’a ichida joylashgan",
                    "Xiva Xonligining siyosiy markazi",
                    "Sharq me’morchiligi namunasi",
                    "Tarixiy qarorlar shu yerda qabul qilingan",
                    "Elchilar qabul qilingan markaz",
                    "Hovlili arxitekturaga ega",
                    "Bugungi kunda muzey sifatida ochiq",
                    "UNESCO hududida joylashgan",
                    "Xivaning eng muhim saroylaridan biri",
                    "Turizm uchun mashhur maskan"
                ],
                images: [ark1, ark2, ark3,]
            },
            {
                title: "Islom Xo‘ja minorasi — Xiva",

                content: `
Islom Xo‘ja minorasi — Xiva shahrining eng baland va eng mashhur me’moriy yodgorliklaridan biridir.

U Ichan-Qal’a hududida joylashgan bo‘lib, Xivaning zamonaviy davr (XX asr boshlar) me’morchiligini ifodalaydi.

Minora shahar panoramasini yuqoridan tomosha qilish imkonini beradigan eng muhim tarixiy nuqtalardan biri hisoblanadi.
    `,

                details: `
Islom Xo‘ja minorasi 1908–1910-yillar oralig‘ida Xiva xoni Isfandiyorxon vaziri Islom Xo‘ja tashabbusi bilan qurilgan.

📌 Arxitektura:
- 45–57 metr atrofida balandlikka ega (Xivaning eng balandi)
- Silindrsimon minora shakli
- Ko‘k, oq va yashil koshinlar bilan bezatilgan
- Islomiy va zamonaviy (o‘sha davr uchun) uslub uyg‘unligi

📌 Tuzilishi:
Minora Islom Xo‘ja madrasasi majmuasining bir qismi hisoblanadi. Majmua:
- madrasa
- minora
- hovli

dan iborat.

📌 Tarixiy ahamiyati:
Bu minora Xivada islohotlar davrining ramzi hisoblanadi va o‘sha davrda ilm-fan, ta’lim va modernizatsiyani rivojlantirish g‘oyalarini ifodalagan.

📌 Qiziqarli jihat:
Minora tepasiga chiqilganda butun Ichan-Qal’a va Xiva shahrining 360° panoramasi ko‘rinadi.
    `,

                facts: [
                    "Xiva shahrida Ichan-Qal’ada joylashgan",
                    "1908–1910-yillarda qurilgan",
                    "Islom Xo‘ja tashabbusi bilan qurilgan",
                    "Xivaning eng baland minorasi",
                    "45–57 metr balandlikka ega",
                    "Islom Xo‘ja madrasasi majmuasiga kiradi",
                    "Silindrsimon shaklga ega",
                    "Ko‘k va yashil koshinlar bilan bezatilgan",
                    "XX asr bosh me’morchiligi",
                    "Islohotlar davri ramzi",
                    "Butun Ichan-Qal’a ko‘rinadi",
                    "Turistik kuzatuv minorasi",
                    "Sharq va zamonaviy uslub uyg‘unligi",
                    "Xiva ramzlaridan biri",
                    "UNESCO hududida joylashgan",
                    "Xivaning eng mashhur obidalaridan biri",
                    "Fotografiya uchun eng yaxshi nuqtalardan biri",
                    "O‘rta Osiyodagi eng chiroyli minoralardan biri",
                    "Islomiy me’morchilik namunasi",
                    "Kechasi yoritilganda juda chiroyli ko‘rinadi"
                ],
                images: [islom1, islom2, islom3,]
            },

            {
                title: "Muhammad Aminxon madrasasi — Xiva",

                content: `
Muhammad Aminxon madrasasi — Xiva shahridagi eng yirik va eng muhim tarixiy madrasalardan biridir.

U Ichan-Qal’aning g‘arbiy qismida joylashgan bo‘lib, Xiva Xonligi davrining ilm-fan va ta’lim markazi sifatida xizmat qilgan.

Bugungi kunda madrasa Xivaning eng mashhur me’moriy obidalaridan biri va sayyohlar uchun ochiq muzey hisoblanadi.
    `,

                details: `
Muhammad Aminxon madrasasi 1852–1855-yillar oralig‘ida Xiva xoni Muhammad Aminxon tomonidan qurdirilgan.

📌 Tarixiy ahamiyati:
- Xiva Xonligidagi eng yirik madrasalardan biri
- Diniy va dunyoviy bilimlar markazi
- Talabalar uchun yirik ilm maskani bo‘lgan

📌 Tuzilishi:
- 2 qavatli katta madrasa
- 130 ga yaqin hujra
- Masjid va darsxona
- Ichki hovli
- Kutubxona va o‘quv xonalari

📌 Arxitektura:
- Pishiq g‘ishtdan qurilgan
- Moviy va oq koshin bezaklar
- Katta peshtoqli kirish qismi
- 5 gumbazli markaziy qism
- Islomiy geometrik naqshlar

📌 Qiziqarli fakt:
Bir paytlar madrasa ichida 250–260 nafar talaba bir vaqtning o‘zida ta’lim olgan.
    `,

                facts: [
                    "Xiva shahrida Ichan-Qal’ada joylashgan",
                    "1852–1855-yillarda qurilgan",
                    "Muhammad Aminxon tomonidan qurdirilgan",
                    "Xiva Xonligidagi eng katta madrasalardan biri",
                    "130 ga yaqin hujra mavjud",
                    "2 qavatli tuzilishga ega",
                    "Diniy va dunyoviy ta’lim berilgan",
                    "250+ talaba o‘qigan",
                    "Pishiq g‘ishtdan qurilgan",
                    "Moviy koshinlar bilan bezatilgan",
                    "Katta markaziy hovli mavjud",
                    "Masjid va darsxona joylashgan",
                    "Xiva me’morchiligining yorqin namunasi",
                    "UNESCO Ichan-Qal’a tarkibida",
                    "Ilm-fan markazi bo‘lgan",
                    "Xonlik davrining eng yirik ta’lim markazi",
                    "Sayyohlar uchun ochiq muzey",
                    "Katta peshtoqli kirish qismiga ega",
                    "Sharq me’morchiligining klassik namunasi",
                    "Bugungi kunda tarixiy obida sifatida saqlanadi"
                ],
                images: [madrasa1, madrasa2, madrasa3,]
            }
        ]
    },


    ru: {
        key: "khiva",
        title: "Хива — музей под открытым небом",

        intro: `
Хива — один из древнейших и лучше всего сохранившихся исторических городов Узбекистана.

Её называют «музеем под открытым небом», поскольку старый город Ичан-Кала практически полностью сохранился в своём первоначальном виде.
    `,

        history: `
История Хивы насчитывает более 2500 лет. В древности город был одним из важнейших центров цивилизации Хорезма.

Во времена Великого шелкового пути Хива играла ключевую роль как крупный торговый город, соединявший Восток и Запад. Через неё проходили многочисленные караваны, способствуя развитию торговли, культуры и науки.

В XVI–XIX веках Хива была столицей Хивинского ханства и развивалась как независимое государство, став важным политическим, экономическим и культурным центром региона.

Главная достопримечательность города — Ичан-Кала, полностью сохранившийся исторический внутренний город, окружённый мощными крепостными стенами. Сегодня этот уникальный архитектурный ансамбль включён в Список всемирного наследия ЮНЕСКО и считается одним из наиболее хорошо сохранившихся средневековых городов Центральной Азии.
    `,

        sections: [
            {
                title: "Ичан-Кала — Хива (Хорезм)",

                content: `
Ичан-Кала — историческая внутренняя крепость Хивы, один из древнейших и лучше всего сохранившихся городских комплексов Узбекистана.

На протяжении многих веков она была центром хорезмской цивилизации, где развивались наука, торговля, культура и государственное управление.

Сегодня Ичан-Кала представляет собой уникальный город-музей под открытым небом, ежегодно привлекающий туристов со всего мира.
    `,

                details: `
Ичан-Кала — внутренняя крепость Хивы, стены которой формировались приблизительно с X по XIX век.

📌 Историческое развитие:
В древности Хива была важным торговым центром Великого шелкового пути. Город являлся частью государства Хорезмшахов, а позднее стал столицей Хивинского ханства.

📌 В состав Ичан-Калы входят:
- Куня-Арк (резиденция ханов)
- Медресе Мухаммада Амин-хана
- Минарет Кальта-Минор
- Джума-мечеть (мечеть с более чем 200 деревянными колоннами)
- Дворец Таш-Хаули
- Минарет и медресе Ислам-Ходжи

📌 Архитектура:
- Древние крепостные стены из сырцового кирпича
- Голубые и зелёные керамические изразцы
- Восточные геометрические орнаменты
- Узкие улицы и переулки
- Средневековая городская планировка

📌 Значение:
Ичан-Кала считается единственным в Центральной Азии полностью сохранившимся древним городом.

В 1990 году исторический комплекс был включён в Список всемирного наследия ЮНЕСКО.
    `,

                facts: [
                    "Расположена в городе Хива, Хорезмская область",
                    "Ичан-Кала — древний внутренний город-крепость",
                    "Включена в Список всемирного наследия ЮНЕСКО (1990)",
                    "Была важным торговым центром Великого шелкового пути",
                    "Хива была столицей государства Хорезмшахов и Хивинского ханства",
                    "Куня-Арк служил резиденцией ханов",
                    "Кальта-Минор известен как недостроенный минарет",
                    "Джума-мечеть насчитывает более 200 деревянных колонн",
                    "Минарет Ислам-Ходжи — самый высокий в Хиве",
                    "Дворец Таш-Хаули был резиденцией ханов",
                    "Крепостные стены построены из сырцового кирпича",
                    "История города насчитывает более 2000 лет",
                    "Ичан-Кала полностью сохранилась как музей под открытым небом",
                    "Один из лучших образцов восточной архитектуры",
                    "На территории расположены многочисленные исторические медресе и мечети",
                    "Городская планировка относится к средневековому периоду",
                    "Внутренние крепостные стены сохранились до наших дней",
                    "Одно из самых популярных туристических мест Узбекистана",
                    "Один из древнейших городов страны",
                    "В вечерней подсветке выглядит особенно впечатляюще"
                ],

                images: [ichan1, ichan2, ichan3],
            },
            {
                title: "Кальта-Минор — Хива",

                content: `
Кальта-Минор — один из самых известных и символичных архитектурных памятников Хивы.

Расположенный в самом сердце Ичан-Калы, он сразу привлекает внимание своим широким основанием и яркой голубой керамической облицовкой.

Несмотря на то что минарет так и не был завершён, сегодня он стал главным символом Хивы и одной из её самых узнаваемых достопримечательностей.
    `,

                details: `
Строительство Кальта-Минора началось в 1851 году по приказу хивинского хана Мухаммада Амин-хана.

Согласно первоначальному замыслу, минарет должен был стать самым высоким не только в Хиве, но и во всей Центральной Азии.

Однако после смерти хана в 1855 году строительство было остановлено, и минарет остался незавершённым.

📌 Архитектурные особенности:
- Широкое и массивное основание
- Облицовка голубыми и зелёными керамическими плитками
- Геометрические исламские орнаменты
- Толстые стены из обожжённого кирпича

📌 Значение:
Кальта-Минор считается «незавершённым, но совершенным символом» Хивы и сегодня является самым фотографируемым памятником города.
    `,

                facts: [
                    "Расположен в Ичан-Кале, городе Хива",
                    "Строительство началось в 1851 году",
                    "Возведён по приказу Мухаммада Амин-хана",
                    "Является незавершённым минаретом",
                    "Главный символ Хивы",
                    "По проекту должен был стать самым высоким минаретом Центральной Азии",
                    "Украшен яркими голубыми керамическими плитками",
                    "Выдающийся памятник архитектуры XIX века",
                    "Находится в центре Ичан-Калы",
                    "Одно из самых фотографируемых мест города",
                    "Уникальный образец восточной архитектуры",
                    "Имеет широкое массивное основание",
                    "Строительство было прекращено в 1855 году",
                    "Относится к периоду Хивинского ханства",
                    "Считается главным архитектурным символом Хивы",
                    "Расположен на территории объекта Всемирного наследия ЮНЕСКО",
                    "Один из самых ярких памятников с голубой керамикой",
                    "Один из самых известных минаретов Центральной Азии",
                    "Обладает огромной исторической и туристической ценностью",
                    "Особенно впечатляет своей подсветкой в вечернее время"
                ],

                images: [kalta1, kalta2, kalta3],
            },
            {
                title: "Куня-Арк — Хива",

                content: `
Куня-Арк — один из важнейших исторических комплексов Хивы, служивший официальной резиденцией хивинских ханов.

Расположенный внутри Ичан-Калы, этот дворцовый ансамбль был центром государственного управления, военного командования и дворцовой жизни ханства.

На протяжении нескольких столетий Куня-Арк оставался политическим и административным сердцем Хивы.
    `,

                details: `
Комплекс Куня-Арк начал формироваться в конце XVII — начале XVIII века и впоследствии неоднократно расширялся.

📌 Состав комплекса:
Куня-Арк включает несколько основных сооружений:
- Ханский дворец (резиденция)
- Залы официальных приёмов
- Диванхана (здание государственного управления)
- Военный арсенал
- Мечеть и молитвенные помещения
- Сторожевые башни

📌 Историческое значение:
Куня-Арк считался сердцем Хивинского ханства. Именно здесь:
- принимались важнейшие государственные решения;
- проходили приёмы иностранных послов;
- разрабатывались военные стратегии.

📌 Архитектура:
- Массивные стены из сырцового кирпича
- Богатые восточные орнаменты и керамические украшения
- Система внутренних дворов
- Крепостные оборонительные стены

Сегодня Куня-Арк является одним из самых посещаемых исторических памятников Хивы.
    `,

                facts: [
                    "Расположен в Ичан-Кале, городе Хива",
                    "Формировался в XVII–XVIII веках",
                    "Был официальной резиденцией хивинских ханов",
                    "Являлся центром государственного управления",
                    "На территории находилась Диванхана",
                    "Служил центром военного управления",
                    "Имеет залы для официальных приёмов",
                    "Включает мечеть и молитвенные помещения",
                    "Построен из сырцового кирпича",
                    "Представляет собой крепостной архитектурный комплекс",
                    "Расположен внутри Ичан-Калы",
                    "Политический центр Хивинского ханства",
                    "Выдающийся образец восточной архитектуры",
                    "Здесь принимались важнейшие государственные решения",
                    "В комплексе принимали иностранных послов",
                    "Имеет традиционную архитектуру с внутренними дворами",
                    "Сегодня открыт для посетителей как музей",
                    "Расположен на территории объекта Всемирного наследия ЮНЕСКО",
                    "Один из важнейших дворцовых комплексов Хивы",
                    "Популярная туристическая достопримечательность"
                ],

                images: [ark1, ark2, ark3],
            },

            {
                title: "Минарет Ислам-Ходжи — Хива",

                content: `
Минарет Ислам-Ходжи — самый высокий и один из самых известных архитектурных памятников Хивы.

Он расположен на территории Ичан-Калы и является выдающимся образцом архитектуры начала XX века, отражающим период модернизации Хивинского ханства.

Сегодня минарет считается одной из главных исторических достопримечательностей города и лучшей смотровой площадкой, с которой открывается панорамный вид на Хиву.
    `,

                details: `
Минарет Ислам-Ходжи был построен в 1908–1910 годах по инициативе Ислам-Ходжи — главного визиря хивинского хана Исфандияр-хана.

📌 Архитектурные особенности:
- Высота около 45–57 метров (самый высокий минарет Хивы)
- Цилиндрическая форма
- Богатая отделка голубыми, белыми и зелёными керамическими плитками
- Гармоничное сочетание традиционной исламской архитектуры и новых архитектурных идей начала XX века

📌 Комплекс:
Минарет является частью архитектурного комплекса Ислам-Ходжи, который включает:
- медресе;
- минарет;
- внутренний двор.

📌 Историческое значение:
Минарет стал символом эпохи реформ в Хивинском ханстве, олицетворяя стремление к развитию образования, науки и модернизации государства.

📌 Интересный факт:
Поднявшись на вершину минарета, можно насладиться великолепной панорамой Ичан-Калы и всей Хивы с обзором почти на 360°.
    `,

                facts: [
                    "Расположен в Ичан-Кале, городе Хива",
                    "Построен в 1908–1910 годах",
                    "Возведён по инициативе Ислам-Ходжи",
                    "Самый высокий минарет Хивы",
                    "Высота составляет около 45–57 метров",
                    "Является частью комплекса медресе Ислам-Ходжи",
                    "Имеет цилиндрическую форму",
                    "Украшен голубыми, белыми и зелёными керамическими плитками",
                    "Выдающийся памятник архитектуры начала XX века",
                    "Символ эпохи реформ Хивинского ханства",
                    "Открывает панорамный вид на всю Ичан-Калу",
                    "Популярная смотровая площадка для туристов",
                    "Сочетает традиционную восточную и современную архитектуру",
                    "Один из главных символов Хивы",
                    "Расположен на территории объекта Всемирного наследия ЮНЕСКО",
                    "Одна из самых известных достопримечательностей города",
                    "Одно из лучших мест для панорамной фотографии",
                    "Один из самых красивых минаретов Центральной Азии",
                    "Выдающийся образец исламской архитектуры",
                    "Особенно эффектно выглядит в вечерней подсветке"
                ],

                images: [islom1, islom2, islom3],
            },
            {
                title: "Медресе Мухаммад Амин-хана — Хива",

                content: `
Медресе Мухаммад Амин-хана — одно из крупнейших и наиболее значимых исторических медресе города Хивы.

Оно расположено в западной части Ичан-Калы и в эпоху Хивинского ханства служило важнейшим центром науки, образования и исламского просвещения.

Сегодня медресе является одним из самых известных архитектурных памятников Хивы и открыто для посещения как музей.
    `,

                details: `
Медресе Мухаммад Амин-хана было построено в 1852–1855 годах по приказу хана Хивы Мухаммад Амин-хана.

📌 Историческое значение:
- Одно из крупнейших медресе Хивинского ханства
- Центр религиозного и светского образования
- Один из важнейших образовательных комплексов своего времени

📌 Структура:
- Большое двухэтажное медресе
- Около 130 келий (худжр)
- Мечеть и учебные классы
- Внутренний двор
- Библиотека и помещения для занятий

📌 Архитектура:
- Построено из обожжённого кирпича
- Украшено голубыми и белыми изразцами
- Монументальный главный портал
- Центральная часть с пятью куполами
- Геометрические орнаменты исламской архитектуры

📌 Интересный факт:
В своё время в медресе одновременно обучалось около 250–260 студентов.
    `,

                facts: [
                    "Расположено в Ичан-Кале, городе Хива",
                    "Построено в 1852–1855 годах",
                    "Возведено по приказу Мухаммад Амин-хана",
                    "Одно из крупнейших медресе Хивинского ханства",
                    "Имеет около 130 келий",
                    "Состоит из двух этажей",
                    "Здесь преподавались религиозные и светские науки",
                    "Одновременно обучалось более 250 студентов",
                    "Построено из обожжённого кирпича",
                    "Украшено голубыми изразцами",
                    "Имеет просторный внутренний двор",
                    "Включает мечеть и учебные помещения",
                    "Выдающийся памятник архитектуры Хивы",
                    "Находится на территории объекта Всемирного наследия ЮНЕСКО «Ичан-Кала»",
                    "Являлось важным научно-образовательным центром",
                    "Крупнейшее учебное заведение периода Хивинского ханства",
                    "Сегодня открыто для посетителей как музей",
                    "Имеет величественный главный портал",
                    "Классический образец восточной исламской архитектуры",
                    "Сохраняется как ценнейший исторический памятник"
                ],

                images: [madrasa1, madrasa2, madrasa3],
            },
        ]
    },
    en: {
        key: "khiva",
        title: "Khiva — The Open-Air Museum City",

        intro: `
Khiva is one of Uzbekistan’s oldest and best-preserved historic cities, with a history spanning more than 2,500 years.

Often referred to as an "open-air museum," Khiva is renowned for its remarkably preserved old town, Ichan-Kala, where centuries of history remain almost untouched.
    `,

        history: `
Khiva has a history of more than 2,500 years and was one of the major centers of the Khorezm civilization.

During the era of the Great Silk Road, Khiva flourished as an important trading city connecting East and West, where merchants, scholars, and travelers from many cultures gathered.

Between the 16th and 19th centuries, Khiva became the capital of the Khiva Khanate and developed into a powerful political, economic, and cultural center of Central Asia.

At the heart of the city lies Ichan-Kala, the historic inner fortress, which has been preserved almost entirely in its original form. Surrounded by massive mud-brick walls, it contains magnificent madrasas, mosques, palaces, minarets, and traditional houses.

Recognized as one of the finest examples of Islamic architecture in Central Asia, Ichan-Kala was inscribed on the UNESCO World Heritage List in 1990.

Today, Khiva is considered one of Uzbekistan's greatest historical treasures and remains one of the country's most popular destinations for travelers from around the world.
    `,

        sections: [
            {
                title: "Ichan-Kala — Khiva (Khorezm)",

                content: `
Ichan-Kala is the historic inner fortress of Khiva and one of the best-preserved ancient walled cities in Uzbekistan.

For centuries, it served as the heart of the Khorezm civilization, where science, trade, culture, and government flourished.

Today, Ichan-Kala is recognized as an extraordinary open-air museum, attracting visitors from all over the world with its remarkable architectural heritage.
    `,

                details: `
Ichan-Kala is the inner fortified city of Khiva, with defensive walls that were gradually constructed between the 10th and 19th centuries.

📌 Historical Background:
Situated along the Great Silk Road, Khiva was one of Central Asia's most important trading centers. It flourished under the Khorezmshahs and later became the capital of the Khiva Khanate.

📌 Main Attractions within Ichan-Kala:
- Kunya Ark (the Khans' residence)
- Muhammad Amin Khan Madrasa
- Kalta Minor Minaret
- Juma Mosque (the Mosque of Wooden Columns)
- Tash Khauli Palace
- Islam Khoja Minaret and Madrasa

📌 Architecture:
- Massive mud-brick defensive walls
- Blue and green glazed tile decorations
- Elegant Islamic geometric patterns
- Narrow streets and winding alleys
- A remarkably preserved medieval urban layout

📌 Significance:
Ichan-Kala is regarded as the only completely preserved ancient walled city in Central Asia.

In 1990, it was inscribed on the UNESCO World Heritage List.
    `,

                facts: [
                    "Located in Khiva, Khorezm Region",
                    "Ichan-Kala is the ancient inner walled city",
                    "Inscribed on the UNESCO World Heritage List in 1990",
                    "An important trading center on the Great Silk Road",
                    "Khiva served as the capital of the Khorezmshahs and later the Khiva Khanate",
                    "Kunya Ark was the official residence of the Khans",
                    "Kalta Minor is famous as an unfinished minaret",
                    "Juma Mosque contains more than 200 carved wooden columns",
                    "Islam Khoja Minaret is the tallest minaret in Khiva",
                    "Tash Khauli Palace served as the royal residence",
                    "The ancient walls were built from mud brick",
                    "The city has a history of more than 2,000 years",
                    "Ichan-Kala is a fully preserved open-air museum city",
                    "One of the finest examples of Islamic architecture in Central Asia",
                    "Home to numerous historic madrasas and mosques",
                    "Its medieval city plan has been preserved",
                    "The inner fortress walls remain largely intact",
                    "One of Uzbekistan's most popular tourist destinations",
                    "One of the country's oldest historic cities",
                    "Beautifully illuminated at night, creating a spectacular atmosphere"
                ],

                images: [ichan1, ichan2, ichan3],
            },
            {
                title: "Kalta Minor — Khiva",

                content: `
Kalta Minor is one of the most iconic and recognizable architectural landmarks in Khiva.

Located in the heart of Ichan-Kala, the minaret immediately captures attention with its massive cylindrical base and brilliant blue glazed tile decoration.

Although it was never completed, Kalta Minor has become the unmistakable symbol of Khiva and one of the city's most photographed monuments.
    `,

                details: `
Construction of Kalta Minor began in 1851 under the order of Muhammad Amin Khan, the ruler of the Khiva Khanate.

According to the original plan, it was intended to become the tallest minaret in Central Asia, serving as a symbol of the khanate's power and prestige.

However, construction came to an abrupt halt in 1855 following the death of Muhammad Amin Khan, leaving the minaret unfinished.

📌 Architectural Features:
- Massive and exceptionally wide cylindrical foundation
- Magnificent blue and turquoise glazed tile decoration
- Elegant Islamic geometric patterns
- Thick baked-brick walls
- Distinctive unfinished structure unlike any other minaret in Central Asia

📌 Significance:
Despite remaining unfinished, Kalta Minor has become Khiva's most recognizable landmark and a masterpiece of Khorezm architecture. Today it stands as one of the city's greatest historical and cultural symbols.
    `,

                facts: [
                    "Located in Ichan-Kala, Khiva",
                    "Construction began in 1851",
                    "Commissioned by Muhammad Amin Khan",
                    "An unfinished minaret",
                    "The most recognizable symbol of Khiva",
                    "Originally planned to become Central Asia's tallest minaret",
                    "Decorated with brilliant blue glazed tiles",
                    "An outstanding example of 19th-century architecture",
                    "Situated in the center of Ichan-Kala",
                    "One of the most photographed landmarks in Khiva",
                    "A unique masterpiece of Islamic architecture",
                    "Features an unusually wide foundation",
                    "Construction stopped in 1855",
                    "Built during the Khiva Khanate",
                    "A defining symbol of the city",
                    "Located within the UNESCO World Heritage Site",
                    "Famous for its vibrant turquoise tilework",
                    "One of Central Asia's best-known minarets",
                    "An important historical and cultural monument",
                    "Beautifully illuminated at night"
                ],

                images: [kalta1, kalta2, kalta3],
            },
            {
                title: "Kunya Ark — Khiva",

                content: `
Kunya Ark is one of the most important historical complexes in Khiva and served as the official residence of the Khiva Khans.

Located within the walls of Ichan-Kala, it was the political, administrative, and military center of the Khiva Khanate, where rulers governed the state and received distinguished guests.

Today, Kunya Ark stands as one of Khiva’s most remarkable historical landmarks, offering visitors a fascinating insight into the city's royal past.
    `,

                details: `
Construction of the Kunya Ark complex began in the late 17th century and continued to expand throughout the 18th and 19th centuries.

📌 Complex Includes:
- The Khan's Palace (Royal Residence)
- Reception Halls
- Divan Khana (Government Administration Hall)
- Military Arsenal
- Mosque and Prayer Rooms
- Watchtowers and Defensive Structures

📌 Historical Significance:
Kunya Ark was considered the political heart of the Khiva Khanate. Here:
- State affairs were managed
- Foreign ambassadors were officially received
- Military strategies were planned
- Royal ceremonies and important governmental events were held

📌 Architecture:
- Massive mud-brick fortress walls
- Beautiful Islamic tilework and decorative ornamentation
- Traditional courtyards
- Strong defensive fortress design
- Elegant examples of Khorezm architectural style

Today, Kunya Ark is one of the most visited historical monuments in Khiva and an essential destination for anyone exploring the UNESCO World Heritage city of Ichan-Kala.
    `,

                facts: [
                    "Located inside Ichan-Kala, Khiva",
                    "Developed between the 17th and 18th centuries",
                    "Served as the residence of the Khiva Khans",
                    "Political center of the Khiva Khanate",
                    "Included the Divan Khana (government office)",
                    "Contained military administration facilities",
                    "Features magnificent reception halls",
                    "Includes a mosque and prayer rooms",
                    "Constructed primarily from mud brick",
                    "Designed as a fortified citadel",
                    "Situated within the walls of Ichan-Kala",
                    "Heart of the Khiva Khanate's administration",
                    "Outstanding example of Khorezm architecture",
                    "Major state decisions were made here",
                    "Foreign ambassadors were officially welcomed here",
                    "Features traditional courtyard architecture",
                    "Open to visitors as a museum today",
                    "Located within the UNESCO World Heritage Site",
                    "One of Khiva's most significant palace complexes",
                    "A must-visit destination for cultural tourism"
                ],

                images: [ark1, ark2, ark3],
            },
            {
                title: "Islam Khoja Minaret — Khiva",

                content: `
The Islam Khoja Minaret is the tallest and one of the most iconic architectural landmarks in the city of Khiva.

Located within the historic walls of Ichan-Kala, it represents the architectural achievements of the early 20th century and serves as one of the city's most recognizable symbols.

Today, visitors can climb the minaret to enjoy breathtaking panoramic views of Ichan-Kala and the ancient city of Khiva.
    `,

                details: `
The Islam Khoja Minaret was built between 1908 and 1910 under the initiative of Islam Khoja, the Grand Vizier of Khiva Khan Isfandiyar Khan.

📌 Architecture:
- Approximately 45–57 meters tall, making it the tallest minaret in Khiva
- Elegant cylindrical design
- Decorated with blue, white, and turquoise glazed tiles
- A harmonious blend of traditional Islamic and early modern architectural styles

📌 Complex:
The minaret forms part of the Islam Khoja Complex, which includes:
- Islam Khoja Madrasa
- The Minaret
- A central courtyard

📌 Historical Significance:
The minaret symbolizes the modernization reforms introduced during the final years of the Khiva Khanate. It reflects the era's commitment to education, science, and cultural development while preserving Islamic traditions.

📌 Interesting Fact:
Visitors who reach the top of the minaret are rewarded with a spectacular 360-degree panoramic view of Ichan-Kala and the entire historic city of Khiva.
    `,

                facts: [
                    "Located in Ichan-Kala, Khiva",
                    "Built between 1908 and 1910",
                    "Commissioned by Islam Khoja",
                    "The tallest minaret in Khiva",
                    "Approximately 45–57 meters high",
                    "Part of the Islam Khoja Madrasa Complex",
                    "Features a graceful cylindrical design",
                    "Decorated with blue, white, and turquoise glazed tiles",
                    "An outstanding example of early 20th-century architecture",
                    "A symbol of the modernization period of the Khiva Khanate",
                    "Offers panoramic views over Ichan-Kala",
                    "One of Khiva's most popular observation points",
                    "Combines traditional Islamic and modern architectural elements",
                    "One of the city's defining landmarks",
                    "Located within the UNESCO World Heritage Site",
                    "Among Khiva's most visited monuments",
                    "A favorite destination for photographers",
                    "One of the most beautiful minarets in Central Asia",
                    "An outstanding masterpiece of Islamic architecture",
                    "Especially impressive when illuminated at night"
                ],

                images: [islom1, islom2, islom3],
            },
            {
                title: "Muhammad Amin Khan Madrasa — Khiva",

                content: `
The Muhammad Amin Khan Madrasa is one of the largest and most significant historic madrasas in the city of Khiva.

Located in the western part of Ichan-Kala, it served as a major center of education, science, and Islamic scholarship during the Khiva Khanate.

Today, the madrasa is one of Khiva's most remarkable architectural landmarks and is open to visitors as a museum.
    `,

                details: `
The Muhammad Amin Khan Madrasa was built between 1852 and 1855 by order of Muhammad Amin Khan, one of the rulers of the Khiva Khanate.

📌 Historical Significance:
- One of the largest madrasas in the Khiva Khanate
- A major center for both religious and secular education
- One of the region's leading institutions of higher learning

📌 Structure:
- A large two-story building
- Approximately 130 student cells (hujras)
- A mosque and classrooms
- A spacious inner courtyard
- A library and study rooms

📌 Architecture:
- Constructed from baked brick
- Decorated with blue and white glazed tiles
- A monumental entrance portal
- A central section crowned with five domes
- Elegant Islamic geometric ornamentation

📌 Interesting Fact:
At its peak, the madrasa accommodated approximately 250–260 students at the same time, making it one of the largest educational institutions in Khiva.
    `,

                facts: [
                    "Located in Ichan-Kala, Khiva",
                    "Built between 1852 and 1855",
                    "Commissioned by Muhammad Amin Khan",
                    "One of the largest madrasas of the Khiva Khanate",
                    "Contains approximately 130 student cells (hujras)",
                    "Designed as a two-story complex",
                    "Provided both religious and secular education",
                    "More than 250 students studied here simultaneously",
                    "Constructed from baked brick",
                    "Decorated with blue and white glazed tiles",
                    "Features a spacious central courtyard",
                    "Includes a mosque and classrooms",
                    "A masterpiece of Khivan architecture",
                    "Located within the UNESCO World Heritage Site of Ichan-Kala",
                    "Served as an important center of learning",
                    "One of the largest educational institutions of the Khiva Khanate",
                    "Open to visitors today as a museum",
                    "Features a magnificent monumental entrance portal",
                    "A classic example of Islamic architecture in Central Asia",
                    "Preserved today as one of Khiva's most valuable historical monuments"
                ],

                images: [madrasa1, madrasa2, madrasa3],
            },
        ]
    },

    fr: {
        key: "khiva",
        title: "Khiva — La ville-musée à ciel ouvert",

        intro: `
Khiva est l'une des villes historiques les plus anciennes et les mieux préservées d'Ouzbékistan, avec plus de 2 500 ans d'histoire.

Surnommée « la ville-musée à ciel ouvert », elle est célèbre pour sa vieille ville fortifiée, Itchan Kala, qui a conservé presque intact son aspect d'origine au fil des siècles.
    `,

        history: `
Avec plus de 2 500 ans d'histoire, Khiva fut l'un des principaux centres de la civilisation du Khorezm.

À l'époque de la Grande Route de la Soie, la ville prospéra comme un important carrefour commercial reliant l'Orient et l'Occident. Marchands, savants et voyageurs de nombreuses cultures y faisaient étape.

Du XVIᵉ au XIXᵉ siècle, Khiva devint la capitale du Khanat de Khiva et se développa en un puissant centre politique, économique et culturel d'Asie centrale.

Au cœur de la ville se trouve Itchan Kala, la citadelle intérieure historique, remarquablement conservée jusqu'à nos jours. Entourée de hauts remparts en briques de terre, elle abrite de magnifiques médersas, mosquées, palais, minarets et maisons traditionnelles.

Considérée comme l'un des plus beaux ensembles de l'architecture islamique d'Asie centrale, Itchan Kala a été inscrite au patrimoine mondial de l'UNESCO en 1990.

Aujourd'hui, Khiva est l'un des plus précieux trésors historiques de l'Ouzbékistan et l'une des destinations touristiques les plus emblématiques du pays.
    `,

        sections: [
            {
                title: "Itchan Kala — Khiva (Khorezm)",

                content: `
Itchan Kala est la cité fortifiée historique de Khiva et l'une des villes anciennes les mieux préservées d'Ouzbékistan.

Pendant des siècles, elle fut le cœur de la civilisation du Khorezm, où se développèrent le commerce, les sciences, la culture et l'administration.

Aujourd'hui, Itchan Kala est un véritable musée à ciel ouvert qui attire des visiteurs du monde entier grâce à son patrimoine architectural exceptionnel.
    `,

                details: `
Itchan Kala constitue la partie intérieure fortifiée de Khiva, dont les remparts ont été édifiés progressivement entre le Xe et le XIXe siècle.

📌 Histoire :
Située sur la Grande Route de la Soie, Khiva était un important centre commercial reliant l'Orient et l'Occident. La ville fut d'abord un centre majeur de l'État des Khorezmchahs avant de devenir la capitale du Khanat de Khiva.

📌 Principaux monuments d'Itchan Kala :
- Kounya Ark (ancienne résidence des khans)
- Médersa Muhammad Amin Khan
- Minaret Kalta Minor
- Mosquée Djouma (Mosquée aux colonnes en bois)
- Palais Tach Khaouli
- Minaret et médersa Islam Khoja

📌 Architecture :
- Impressionnants remparts en briques de terre
- Faïences émaillées bleues et vertes
- Élégants motifs géométriques islamiques
- Rues étroites et ruelles pittoresques
- Urbanisme médiéval remarquablement conservé

📌 Importance :
Itchan Kala est considérée comme la seule ville fortifiée d'Asie centrale conservée presque intégralement dans son état d'origine.

En 1990, elle a été inscrite au patrimoine mondial de l'UNESCO.
    `,

                facts: [
                    "Située à Khiva, dans la région du Khorezm",
                    "La vieille ville fortifiée de Khiva",
                    "Inscrite au patrimoine mondial de l'UNESCO en 1990",
                    "Ancien centre commercial majeur de la Route de la Soie",
                    "Capitale des Khorezmchahs puis du Khanat de Khiva",
                    "Kounya Ark était la résidence officielle des khans",
                    "Kalta Minor est célèbre pour être un minaret inachevé",
                    "La mosquée Djouma possède plus de 200 colonnes en bois sculpté",
                    "Le minaret Islam Khoja est le plus haut de Khiva",
                    "Le palais Tach Khaouli était la résidence royale",
                    "Les remparts sont construits en briques de terre",
                    "La ville possède plus de 2 000 ans d'histoire",
                    "Un musée à ciel ouvert parfaitement préservé",
                    "L'un des plus beaux ensembles d'architecture islamique d'Asie centrale",
                    "Abrite de nombreuses médersas et mosquées historiques",
                    "Son plan urbain médiéval est resté intact",
                    "Les remparts historiques sont toujours debout",
                    "L'une des destinations touristiques les plus célèbres d'Ouzbékistan",
                    "L'une des plus anciennes villes du pays",
                    "Magnifiquement illuminée à la tombée de la nuit"
                ],

                images: [ichan1, ichan2, ichan3],
            },
            {
                title: "Kalta Minor — Khiva",

                content: `
Kalta Minor est l’un des monuments architecturaux les plus célèbres et les plus emblématiques de Khiva.

Situé au cœur d’Itchan Kala, il attire immédiatement l’attention grâce à sa base imposante et à ses magnifiques carreaux de faïence bleus éclatants.

Bien que sa construction n’ait jamais été achevée, Kalta Minor est devenu le symbole le plus reconnaissable de Khiva.
    `,

                details: `
La construction de Kalta Minor débuta en 1851 sous le règne du khan Muhammad Amin Khan.

À l’origine, il était destiné à devenir un minaret exceptionnellement haut, censé être le plus élevé d’Asie centrale.

Cependant, après la mort du khan en 1855, les travaux furent interrompus et le minaret resta inachevé.

📌 Caractéristiques architecturales :
- Base large et massive
- Revêtement de carreaux de faïence bleus et verts
- Motifs géométriques de l’art islamique
- Épais murs en briques cuites

📌 Importance :
Bien qu’inachevé, Kalta Minor est considéré comme « le symbole inachevé mais parfait » de Khiva et demeure aujourd’hui l’un des monuments les plus photographiés de la ville.
    `,

                facts: [
                    "Situé à Itchan Kala, dans la ville de Khiva",
                    "La construction a commencé en 1851",
                    "Commandé par Muhammad Amin Khan",
                    "Minaret resté inachevé",
                    "Le symbole le plus célèbre de Khiva",
                    "Aurait été le plus haut minaret d’Asie centrale s’il avait été terminé",
                    "Décoré de magnifiques carreaux de faïence bleus",
                    "Chef-d’œuvre de l’architecture du XIXᵉ siècle",
                    "Situé au centre d’Itchan Kala",
                    "L’un des monuments les plus photographiés de Khiva",
                    "Exemple remarquable de l’architecture orientale",
                    "Possède une base exceptionnellement large",
                    "Les travaux furent interrompus en 1855",
                    "Monument datant du khanat de Khiva",
                    "Considéré comme l’emblème principal de Khiva",
                    "Situé dans le site classé au patrimoine mondial de l’UNESCO",
                    "L’un des monuments aux carreaux bleus les plus impressionnants d’Ouzbékistan",
                    "L’un des minarets les plus célèbres d’Asie centrale",
                    "Possède une immense valeur historique et touristique",
                    "Particulièrement spectaculaire lorsqu’il est illuminé la nuit"
                ],

                images: [kalta1, kalta2, kalta3],
            },
            {
                title: "Ko‘hna Ark — Khiva",

                content: `
Ko‘hna Ark est l’un des ensembles historiques les plus importants de Khiva. Il servait de résidence officielle aux khans de Khiva pendant plusieurs siècles.

Situé à l'intérieur d’Itchan Kala, il était le centre du pouvoir politique, de l'administration et des affaires militaires du khanat.

Aujourd’hui, Ko‘hna Ark est l’un des monuments historiques les plus visités de Khiva et offre un aperçu fascinant de la vie des souverains de la ville.
    `,

                details: `
Ko‘hna Ark a commencé à prendre sa forme actuelle à la fin du XVIIᵉ siècle et au début du XVIIIᵉ siècle, avant d’être progressivement agrandi.

📌 Composition du complexe :
- Palais du khan (résidence royale)
- Salles de réception officielles
- Divankhana (centre administratif)
- Arsenal militaire
- Mosquée et salles de prière
- Tours d’observation

📌 Importance historique :
Ko‘hna Ark était le cœur politique du khanat de Khiva. C’est ici que :
- les décisions gouvernementales étaient prises,
- les ambassadeurs étrangers étaient reçus,
- les stratégies militaires étaient élaborées.

📌 Architecture :
- Épais remparts construits en briques d’argile
- Décorations traditionnelles en carreaux de faïence
- Plusieurs cours intérieures
- Fortifications de style oriental

Aujourd’hui, Ko‘hna Ark est transformé en musée et constitue l’un des principaux sites touristiques de Khiva.
    `,

                facts: [
                    "Situé à Itchan Kala, dans la ville de Khiva",
                    "Développé entre les XVIIᵉ et XVIIIᵉ siècles",
                    "Résidence officielle des khans de Khiva",
                    "Ancien centre du gouvernement",
                    "Possédait un Divankhana (centre administratif)",
                    "Comprenait des installations militaires",
                    "Abrite plusieurs salles de réception",
                    "Dispose d’une mosquée et de salles de prière",
                    "Construit en briques d’argile",
                    "Forteresse de style oriental",
                    "Situé à l’intérieur des remparts d’Itchan Kala",
                    "Ancien cœur politique du khanat de Khiva",
                    "Excellent exemple de l’architecture traditionnelle d’Asie centrale",
                    "Lieu où étaient prises les décisions d’État",
                    "Accueillait les ambassadeurs étrangers",
                    "Conçu autour de plusieurs cours intérieures",
                    "Ouvert aujourd’hui en tant que musée",
                    "Situé dans le site classé au patrimoine mondial de l’UNESCO",
                    "L’un des palais historiques les plus importants de Khiva",
                    "L’un des sites touristiques les plus populaires de la ville"
                ],

                images: [ark1, ark2, ark3],
            },
            {
                title: "Minaret Islam Khoja — Khiva",

                content: `
Le minaret Islam Khoja est le plus haut et l’un des monuments architecturaux les plus emblématiques de Khiva.

Situé à l’intérieur d’Itchan Kala, il représente l’architecture de la période de modernisation du début du XXᵉ siècle.

Depuis son sommet, les visiteurs peuvent admirer une vue panoramique exceptionnelle sur toute la vieille ville de Khiva, ce qui en fait l’un des sites historiques les plus remarquables de la cité.
    `,

                details: `
Le minaret Islam Khoja a été construit entre 1908 et 1910 à l’initiative d’Islam Khoja, grand vizir du khan Isfandiyar de Khiva.

📌 Architecture :
- D’une hauteur d’environ 45 à 57 mètres (le plus haut minaret de Khiva)
- Forme cylindrique élancée
- Décoré de carreaux de faïence bleus, blancs et verts
- Alliance harmonieuse entre l’architecture islamique traditionnelle et les influences modernes de l’époque

📌 Composition du complexe :
Le minaret fait partie du complexe de la médersa Islam Khoja, comprenant :
- une médersa,
- le minaret,
- une cour intérieure.

📌 Importance historique :
Le minaret est considéré comme le symbole des réformes entreprises à Khiva au début du XXᵉ siècle. Il reflète la volonté de promouvoir l’éducation, les sciences et la modernisation de la société.

📌 Fait intéressant :
Depuis le sommet du minaret, les visiteurs profitent d’une vue panoramique à 360° sur Itchan Kala et l’ensemble de la ville historique de Khiva.
    `,

                facts: [
                    "Situé à Itchan Kala, dans la ville de Khiva",
                    "Construit entre 1908 et 1910",
                    "Édifié à l’initiative d’Islam Khoja",
                    "Le plus haut minaret de Khiva",
                    "Mesure environ 45 à 57 mètres de hauteur",
                    "Fait partie du complexe de la médersa Islam Khoja",
                    "Possède une forme cylindrique élancée",
                    "Décoré de carreaux de faïence bleus, verts et blancs",
                    "Chef-d’œuvre architectural du début du XXᵉ siècle",
                    "Symbole de la période des réformes à Khiva",
                    "Offre une vue panoramique sur toute Itchan Kala",
                    "L’un des meilleurs points d’observation de la ville",
                    "Mélange d’architecture orientale traditionnelle et de modernité",
                    "L’un des symboles les plus célèbres de Khiva",
                    "Situé dans le site classé au patrimoine mondial de l’UNESCO",
                    "L’un des monuments les plus visités de Khiva",
                    "Un lieu privilégié pour les photographes",
                    "Considéré comme l’un des plus beaux minarets d’Asie centrale",
                    "Magnifique exemple de l’architecture islamique",
                    "Particulièrement spectaculaire lorsqu’il est illuminé la nuit"
                ],

                images: [islom1, islom2, islom3],
            },

            {
                title: "Médersa Muhammad Amin Khan — Khiva",

                content: `
La médersa Muhammad Amin Khan est l’une des plus grandes et des plus importantes médersas historiques de Khiva.

Située dans la partie occidentale d’Itchan Kala, elle fut l’un des principaux centres d’enseignement et de savoir du khanat de Khiva.

Aujourd’hui, la médersa est l’un des monuments architecturaux les plus célèbres de Khiva et accueille les visiteurs en tant que musée historique.
    `,

                details: `
La médersa Muhammad Amin Khan a été construite entre 1852 et 1855 sur ordre du khan Muhammad Amin Khan.

📌 Importance historique :
- L’une des plus grandes médersas du khanat de Khiva
- Centre d’enseignement religieux et laïque
- Importante institution éducative accueillant des centaines d’étudiants

📌 Structure :
- Grande médersa de deux étages
- Près de 130 cellules (hujras)
- Mosquée et salles de classe
- Cour intérieure
- Bibliothèque et salles d’étude

📌 Architecture :
- Construite en briques cuites
- Décorée de magnifiques carreaux de faïence bleus et blancs
- Impressionnant portail monumental
- Partie centrale coiffée de cinq coupoles
- Riches motifs géométriques de l’art islamique

📌 Fait intéressant :
À son apogée, la médersa accueillait simultanément entre 250 et 260 étudiants.
    `,

                facts: [
                    "Située à Itchan Kala, dans la ville de Khiva",
                    "Construite entre 1852 et 1855",
                    "Commandée par Muhammad Amin Khan",
                    "L’une des plus grandes médersas du khanat de Khiva",
                    "Comprend près de 130 cellules (hujras)",
                    "Édifice de deux étages",
                    "Dispensait un enseignement religieux et laïque",
                    "Accueillait plus de 250 étudiants",
                    "Construite en briques cuites",
                    "Décorée de carreaux de faïence bleus",
                    "Possède une vaste cour centrale",
                    "Comprend une mosquée et des salles de cours",
                    "Magnifique exemple de l’architecture de Khiva",
                    "Fait partie du site d’Itchan Kala classé par l’UNESCO",
                    "Ancien centre majeur du savoir",
                    "La plus importante institution éducative du khanat",
                    "Ouverte aujourd’hui comme musée",
                    "Dotée d’un imposant portail d’entrée",
                    "Chef-d’œuvre de l’architecture islamique d’Asie centrale",
                    "Préservée comme monument historique"
                ],

                images: [madrasa1, madrasa2, madrasa3],
            },
        ]
    }
};

export default khiva;